module.exports = __webpack_public_path__ + "img/notificaciones.df5df3bc.png";